module.exports = __webpack_public_path__ + "assets/directory.png?b84f1af3d36868ee91e77ea99b690d4b";